import axios from 'axios';
import { store } from '../store';
import { LOGOUT } from '../actions/types';

// Create an instance of axios
export const BASE_AI_URL = `${process.env.REACT_APP_AI_BASE_URL}`

const apiAi = axios.create({
    baseURL: `${BASE_AI_URL}`,
    headers: {
        'Content-Type': 'application/json'
    }
});

apiAi.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response.status === 401) {
            store.dispatch({ type: LOGOUT });
        }
        return Promise.reject(err);
    }
);

export default apiAi;
